<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>商家画像</div>
    </div>

    <el-row class="filter">
      <div style="width: 95%; margin: 0 auto; padding-top: 5px">
        <span>商家信息</span>
        <el-button
          type="success"
          size="mini"
          style="float: right"
          @click="updateSupply"
          >编辑</el-button
        >
      </div>
      <p style="width: 100%; border-bottom: solid 1px #e0e0e0" />
      <div style="width: 95%; margin: 0 auto; color: gray">
        <div v-if="resData.profile" style="float: left; width: 33%">
          <p>
            <label>商家名称：</label
            ><span>{{ resData.profile.supply_name }}</span>
          </p>
          <p>
            <label>城市：</label><span>{{ resData.profile.supply_city }}</span>
          </p>
          <p>
            <label>市场：</label
            ><span>{{ resData.profile.father_market }}</span>
          </p>
          <p>
            <label>子市场：</label><span>{{ resData.profile.market }}</span>
          </p>
          <p>
            <label>楼层：</label><span>{{ resData.profile.supply_floor }}</span>
          </p>
          <p>
            <label>区域/街 ：</label
            ><span>{{ resData.profile.supply_area }}</span>
          </p>
          <p>
            <label>档口号：</label
            ><span>{{ resData.profile.supplier_num }}</span>
          </p>
          <p>
            <label>品牌：</label><span>{{ resData.profile.brands }}</span>
          </p>
          <p>
            <label>联系方式：</label
            ><span @click="handleGetPrivateInfo('supply_mobile_phone')">{{
              resData.profile.supply_mobile_phone
            }}</span>
          </p>
          <p>
            <label>微信昵称：</label
            ><span @click="handleGetPrivateInfo('supply_wechat')">{{
              resData.profile.supply_wechat
            }}</span>
          </p>
        </div>
        <div v-if="resData.profile" style="float: left; width: 33%">
          <div style="width: 100%; float: left">
            <p style="float: left">
              <label>收款人信息 ：</label>
            </p>
            <p
              v-for="(payee, index) in resData.profile.payees"
              :key="index"
              @click="handleGetPrivateInfo('payees')"
            >
              {{ payee.payee_name }}-{{ payee.payee_bank }}-{{
                payee.payee_bank_account
              }}
            </p>
          </div>
          <p>
            <label>是否可刷单：</label
            ><span>{{ resData.profile.supply_is_scal }}</span>
          </p>
          <p>
            <label>商家状态：</label
            ><span>{{ resData.profile.supply_supply_status }}</span>
          </p>
          <p>
            <label>绑定代采组：</label><span>{{ resData.profile.pgname }}</span>
          </p>
          <p>
            <label>买手组：</label><span>{{ resData.profile.pg_name }}</span>
          </p>
          <p>
            <label>代采员：</label><span>{{ resData.profile.mbmber }}</span>
          </p>
          <p>
            <label>锁定排单天数：</label
            ><span>{{ resData.profile.limit_day }}</span>
          </p>
          <p>
            <label>是否实力档口：</label
            ><span>{{ resData.profile.supply_is_strength }}</span>
          </p>
          <p>
            <label>擅长季节：</label><span>{{ resData.profile.season }}</span>
          </p>
          <p>
            <label>擅长品类：</label><span>{{ resData.profile.cats }}</span>
          </p>
        </div>
        <div v-if="resData.profile" style="float: left; width: 33%">
          <p>
            <label>主要风格：</label><span>{{ resData.profile.styles }}</span>
          </p>
          <p>
            <label>适应年龄段：</label
            ><span>{{ resData.profile.age_group }}</span>
          </p>
          <label style="float: left; width: 20%">档口图片：</label>
          <div
            v-viewer
            style="
              width: 80%;
              overflow: hidden;
              cursor: pointer;
              margin: auto;
              float: left;
              height: 44px;
            "
          >
            <img
              :src="resData.profile.pic"
              alt=""
              style="width: 40px; height: 40px"
            />
          </div>
          <label style="float: left; width: 20%">营业执照：</label>
          <div
            v-viewer
            style="
              width: 80%;
              overflow: hidden;
              cursor: pointer;
              margin: auto;
              float: left;
              height: 44px;
            "
          >
            <img
              :src="resData.profile.license"
              alt=""
              style="width: 44px; height: 44px"
            />
          </div>
          <label style="float: left; width: 20%">档口头像：</label>
          <div
            v-viewer
            style="
              width: 80%;
              overflow: hidden;
              cursor: pointer;
              margin: auto;
              float: left;
              height: 44px;
            "
          >
            <img
              :src="resData.profile.avatar"
              alt=""
              style="width: 44px; height: 44px"
            />
          </div>

          <p>
            <label>档口优点：</label
            ><span>{{ resData.profile.advantage }}</span>
          </p>

          <p>
            <label>档口缺点：</label
            ><span>{{ resData.profile.disadvantage }}</span>
          </p>
          <p>
            <label>商家地址：</label
            ><span @click="handleGetPrivateInfo('supply_address')">{{
              resData.profile.supply_address
            }}</span>
          </p>
          <p>
            <label>爆版余额：</label
            ><span @click="handleGetPrivateInfo('supply_balance')">{{
              resData.profile.supply_balance
            }}</span>
          </p>
        </div>
      </div>
    </el-row>
    <SupplyFulfillDetail :supply-id="supplyId"></SupplyFulfillDetail>
    <el-row class="filter">
      <div style="width: 95%; margin: 0 auto; padding-top: 5px">
        <span>数据标签</span>
      </div>
      <p style="width: 100%; border-bottom: solid 1px #e0e0e0" />
      <div
        v-if="resData.portrait"
        style="width: 95%; margin: 0 auto; color: gray"
      >
        <div style="float: left; width: 33%">
          <!--<p>-->
          <!--<el-tooltip class="item" effect="dark" content="Top Left 提示文字" placement="top-start">-->
          <!--<i class="el-icon-info"></i>-->
          <!--</el-tooltip>-->
          <!--<label>平均排单天数：</label><span>{{resData.profile.supply_name}}</span>-->
          <!--</p>-->
          <p>
            <el-tooltip
              class="item"
              effect="dark"
              content="用户申请无理由退换件数/发货件数"
              placement="top-start"
            >
              <i class="el-icon-info" />
            </el-tooltip>
            <label>无理由退换率：</label
            ><span>{{ resData.portrait.noreason_rates }}</span>
          </p>
          <p>
            <el-tooltip
              class="item"
              effect="dark"
              content="剔除掉商品异常和物流问题的工单件数/发货件数"
              placement="top-start"
            >
              <i class="el-icon-info" />
            </el-tooltip>
            <label>工单率：</label
            ><span>{{ resData.portrait.problem_rates }}</span>
          </p>
          <p>
            <el-tooltip
              class="item"
              effect="dark"
              content="质量平均分"
              placement="top-start"
            >
              <i class="el-icon-info" />
            </el-tooltip>
            <label>商品质量评分：</label
            ><span>{{ resData.portrait.ave_quality_va }}</span>
          </p>
          <p>
            <el-tooltip
              class="item"
              effect="dark"
              content="性价比&质量&热卖的平均分"
              placement="top-start"
            >
              <i class="el-icon-info" />
            </el-tooltip>
            <label>商品满意度：</label
            ><span>{{ resData.portrait.avergesocre_va }}</span>
          </p>
          <p>
            <el-tooltip
              class="item"
              effect="dark"
              content="用户申请质量问题件数/发货件数"
              placement="top-start"
            >
              <i class="el-icon-info" />
            </el-tooltip>
            <label>次品率：</label
            ><span>{{ resData.portrait.service_rates }}</span>
          </p>
        </div>
        <div v-if="resData.portrait" style="float: left; width: 33%">
          <p>
            <el-tooltip
              class="item"
              effect="dark"
              content="成交 GMV（[300000,+):极高、[80000,300000)：高、[50000,80000)：一般、[0,50000)：低）"
              placement="top-start"
            >
              <i class="el-icon-info" />
            </el-tooltip>
            <label>月均拿货水平：</label
            ><span
              >{{ resData.portrait.amount }}({{
                resData.portrait.amount_range
              }})</span
            >
          </p>
          <p>
            <el-tooltip
              class="item"
              effect="dark"
              content="商品2次（含）以上购买的用户数/购买用户数（[15%,+)：极高、[11%，15%)：高、[8%,11%)：一般、[0,8%)：低、用户数<100：不计）"
              placement="top-start"
            >
              <i class="el-icon-info" />
            </el-tooltip>
            <label>复购率水平：</label
            ><span
              >{{ resData.portrait.fg_user_rates }}({{
                resData.portrait.fg_rates_range
              }})</span
            >
          </p>
          <p>
            <el-tooltip
              class="item"
              effect="dark"
              content="成交件数>=30件的款数占比（[30%,+)达标）"
              placement="top-start"
            >
              <i class="el-icon-info" />
            </el-tooltip>
            <label>整体销售水平：</label
            ><span
              >{{ resData.portrait.whole_rates }}({{
                resData.portrait.whole_rates_range
              }})</span
            >
          </p>
          <p>
            <el-tooltip
              class="item"
              effect="dark"
              content="成交件数>=70件的款数占比（[8%,+)达标）"
              placement="top-start"
            >
              <i class="el-icon-info" />
            </el-tooltip>
            <label>爆款水平：</label
            ><span
              >{{ resData.portrait.hot_rates }}({{
                resData.portrait.hot_rates_range
              }})</span
            >
          </p>
          <p>
            <el-tooltip
              class="item"
              effect="dark"
              content="成交件数>=5件的款数占比（[8%,+)达标）"
              placement="top-start"
            >
              <i class="el-icon-info" />
            </el-tooltip>
            <label>成团率水平：</label
            ><span
              >{{ resData.portrait.engough_rates }}({{
                resData.portrait.engough_rates_range
              }})</span
            >
          </p>
        </div>
        <div v-if="resData.portrait" style="float: left; width: 33%">
          <p>
            <el-tooltip
              class="item"
              effect="dark"
              content="第一次商品上架的专场时间"
              placement="top-start"
            >
              <i class="el-icon-info" />
            </el-tooltip>
            <label>首次合作日期：</label
            ><span>{{ resData.portrait.cop_time }}</span>
          </p>
          <p>
            <el-tooltip
              class="item"
              effect="dark"
              content="最近一次商品上架的专场时间"
              placement="top-start"
            >
              <i class="el-icon-info" />
            </el-tooltip>
            <label>上次合作日期：</label
            ><span>{{ resData.portrait.last_time }}</span>
          </p>
        </div>
      </div>
    </el-row>

    <el-row v-if="resData" class="filter">
      <div style="width: 95%; margin: 0 auto; padding-top: 5px">
        <span>商家代采报表</span>
        <el-button
          type="success"
          size="mini"
          style="float: right"
          @click="wcg_order_detail"
          >查看明细</el-button
        >
      </div>
      <p style="width: 100%; border-bottom: solid 1px #e0e0e0" />
      <el-col>
        <template>
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            border
            :data="resData.wcg_order"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <!--<el-table-column align="center" prop="supply_id" label="商家代采报表">-->
            <el-table-column
              align="center"
              prop="all_num"
              label="实际报单"
            ></el-table-column>
            <el-table-column
              prop="num"
              label="已入库"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="rj_owe_num"
              label="退换欠货"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="owe_num"
              label="代采欠货"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="ded_num"
              label="转抵扣"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="refund_num"
              label="已退款"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="baddebt_num"
              label="呆账"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="broken_num"
              label="坏账"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <!--</el-table-column>-->
          </el-table>
        </template>
      </el-col>
    </el-row>
    <el-row class="filter">
      <div style="width: 95%; margin: 0 auto; padding-top: 5px">
        <span
          >代采履约情况
          <el-tooltip class="item" effect="dark" placement="top-start">
            <div slot="content">
              以下均为推前7天算起的{{ portrait_data_value }}天内的统计数据<br />
              开单率：实际开单的代采订单商品数量/计划代采的商品数量<br />
              回货率：实际入库的商品数量/代采订单的商品数量<br />
              配货率：实际配货的商品数量/应配的商品数量（剔除不成团、主动取消的商品）<br />
              实发率：实际发出的商品数量/应配的商品数量（剔除不成团、主动取消的商品）<br />
            </div>
            <i class="el-icon-info" />
          </el-tooltip>
        </span>
        <div style="float: right">
          <el-button size="mini" style="" @click="setData(7)">7天</el-button>
          <el-button size="mini" style="" @click="setData(15)">15天</el-button>
          <el-button size="mini" style="" @click="setData(30)">30天</el-button>
          <el-button size="mini" style="" @click="setData(90)">90天</el-button>
        </div>
      </div>
      <p style="width: 100%; border-bottom: solid 1px #e0e0e0" />
      <el-col>
        <template>
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            border
            :data="portrait_data"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <!--<el-table-column align="center" prop="supply_id" label="代采履约情况">-->
            <el-table-column align="center" label="开单率">
              <el-table-column
                prop="24_billing_rates"
                label="24小时"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="48_billing_rates"
                label="48小时"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="end_billing_rates"
                label="最终"
                align="center"
              >
              </el-table-column>
            </el-table-column>
            <el-table-column
              label="回货率"
              show-overflow-tooltip
              align="center"
            >
              <el-table-column
                prop="24_stock_rates"
                label="24小时"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="48_stock_rates"
                label="48小时"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="end_stock_rates"
                label="最终"
                align="center"
              >
              </el-table-column>
            </el-table-column>
            <el-table-column
              label="配货率"
              show-overflow-tooltip
              align="center"
            >
              <el-table-column
                prop="24_allot_rates"
                label="24小时"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="48_allot_rates"
                label="48小时"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="end_allot_rates"
                label="最终"
                align="center"
              >
              </el-table-column>
            </el-table-column>
            <el-table-column
              label="实发率"
              show-overflow-tooltip
              align="center"
            >
              <el-table-column
                prop="24_ship_rates"
                label="24小时"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="48_ship_rates"
                label="48小时"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="end_ship_rates"
                label="最终"
                align="center"
              >
              </el-table-column>
            </el-table-column>
            <!--</el-table-column>-->
          </el-table>
        </template>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import SupplyFulfillDetail from "./components/SupplyFulfillDetail.vue";
import { getInformationPrivate } from "@/controller/supply.js";

export default {
  components: { SupplyFulfillDetail },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      supplyId: "",
      resData: {},
      url: "/erp/Supply/profile",
      filterable: true,
      loading: false,
      tableLoading: false,
      form: {},
      portrait_data: null,
      portrait_data_value: 7,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  mounted() {
    this.supplyId = this.$route.params.id;
  },
  methods: {
    setData(value) {
      this.portrait_data_value = value;
      console.log(this.resData.portrait_data[value]);
      this.portrait_data = this.resData.portrait_data[value];
    },
    fetchData(showLoading) {
      if (this.$route.params.id) {
        if (showLoading) {
          this.loading = true;
        }
        this.$http
          .get(
            `${this.url}/supply_id/${this.$route.params.id}`,
            this.filteredForm
          )
          .then((res) => {
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              const { data } = res.data;
              if (JSON.stringify(data) !== "[]") {
                data.wcg_order = this.resFormat(data);
              }
              this.resData = res.data.data;
              this.portrait_data = this.resData.portrait_data[7];
            }
          });
      }
    },
    updateSupply() {
      this.$router.push(`/home/supply/updatesupply/${this.$route.params.id}`);
    },
    wcg_order_detail() {
      this.$router.push(
        `/home/purchasing/report?supply_name=${this.resData.profile.supply_name}`
      );
    },
    resFormat(data) {
      return data.wcg_order.map((v) => {
        const item = v;
        item.all_num = `${item.all_num} / ${item.all_price}`;
        item.bad_num = `${item.bad_num} / ${item.bad_price}`;
        item.num = `${item.num} / ${item.price}`;
        item.refund_num = `${item.refund_num} / ${item.refund_price}`;
        item.ded_num = `${item.ded_num} / ${item.ded_price}`;
        item.owe_num = `${item.owe_num} / ${item.owe_price}`;
        item.hexiao_num = `${item.hexiao_num} / ${item.hexiao_price}`;
        item.baddebt_num = `${item.baddebt_num} / ${item.baddebt_price}`;
        item.rj_owe_num = `${item.rj_owe_num} / ${item.rj_owe_price}`;
        item.broken_num = `${item.broken_num} / ${item.broken_price}`;
        return item;
      });
    },
    // 获取私密信息接口
    handleGetPrivateInfo(type) {
      const params = {
        supply_id: this.$route.params.id,
        getType: type,
      };
      getInformationPrivate(params)
        .then((data) => {
          const {
            payees,
            supply_address: supplyAddress,
            supply_mobile_phone: supplyMobilePhone,
            supply_wechat: supplyWechat,
            supply_balance: supplyBalance,
          } = data;
          switch (type) {
            case "payees": {
              this.resData.profile.payees = payees;
              break;
            }
            case "supply_mobile_phone": {
              this.resData.profile.supply_mobile_phone = supplyMobilePhone;
              break;
            }
            case "supply_address": {
              this.resData.profile.supply_address = supplyAddress;
              break;
            }
            case "supply_wechat": {
              this.resData.profile.supply_wechat = supplyWechat;
              break;
            }
            case "supply_balance": {
              this.resData.profile.supply_balance = supplyBalance;
              break;
            }
            default: {
              break;
            }
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/supply/Profile.vue